<script setup lang="ts">
import { RouterView } from 'vue-router'
import { LoadingSpinner } from '@/components';
import { useSpinnerStore } from '@/stores';

const spinner = useSpinnerStore()
</script>

<template>
  <RouterView v-slot="{ Component }">
    <template v-if="Component">
      <Suspense @fallback="spinner.show()" @resolve="spinner.hide()">
        <component :is="Component"></component>
      </Suspense>
    </template>
  </RouterView>
  <LoadingSpinner />
</template>
